import React from "react";
import { ProductCardSolution } from "./ProductCardSolution";
import cardImage1 from "assets/images/solutionTrade.svg";
import cardImage2 from "assets/images/solutionFinance.jpg";
import cardImage3 from "assets/images/solutionPay.svg";
import { ROUTES } from "constants/navigation";
import { LOCALE_STRINGS } from "constants/locales";

export const SolutionsSection = ({ language = "EN" }) => {
  const strings = LOCALE_STRINGS[language] || LOCALE_STRINGS.EN;

  const solutionsData = [
    {
      id: "trade",
      img: cardImage1,
      title: strings.nav_trade || "Trade",
      content:
        strings.home_solutions_card1_content ||
        "Source globally - trade with certainty",
      path: ROUTES.trade?.path || `${ROUTES.solutions?.path}/trade`,
    },
    {
      id: "finance",
      img: cardImage2,
      title: strings.nav_finance || "Finance",
      content:
        strings.home_solutions_card2_content ||
        "Credit that reads your trade not your statements",
      path: ROUTES.finance?.path || `${ROUTES.solutions?.path}/finance`,
    },
    {
      id: "pay",
      img: cardImage3,
      title: strings.nav_pay || "Pay",
      content:
        strings.home_solutions_card3_content ||
        "Payments that move at the speed of trade",
      path: ROUTES.pay?.path || `${ROUTES.solutions?.path}/pay`,
    },
  ];

  return (
    <section className="solutions-section">
      <div className="solutions-header">
        <h2 className="solutions-heading">
          {strings.home_solutions_title || "Our Solutions"}
        </h2>

        {strings.home_solutions_subtitle && (
          <p className="solutions-supporting-text">
            {strings.home_solutions_subtitle}
          </p>
        )}
      </div>

      <div className="solutions-grid">
        {solutionsData.map((item) => (
          <ProductCardSolution
            key={item.id}
            img={item.img}
            title={item.title}
            content={item.content}
            path={item.path}
            learnMoreText={strings.learn_more || "Learn More"}
          />
        ))}
      </div>
    </section>
  );
};